<!--
  2021-09-29 C007 实现新的Landing模板
-->
<template>
  <div class="main-content">
    <img
      :src="landing"
      style="width: 100%; display: block; padding: 0 0 0 0"
    />
    <div class="coin">
      <div class="coin_bg">
        <div class="title">
          <img :src="telegram">
          <span>For more information please contact us:</span>
        </div>
        <div class="row">
          <div class="whatsup" :style="{backgroundImage:'url('+require('../../assets/images/common/whatsup.png')+')'}"
               @click="goto(link2)">
            <span> LIVE CHAT</span>
          </div>
          <!--          <span class="w_text">Telegram:</span><span class="b_text" @click="goto">+91 82645 23599</span>-->
        </div>
        <!--        <div class="row">-->
        <!--          <span class="w_text">Official Channel:</span><span class="b_text" @click="goto">{{ link }}</span>-->
        <!--        </div>-->
        <!--        <img class="oneCoin" :src="oneCoin">-->
      </div>
    </div>
<!--    <div class="black"></div>-->
    <!--    <img :src="join" style="width: calc(100% + 2px); display: block;position: fixed;bottom: 0" @click="joinNow">-->
  </div>
</template>

<script>
import join from '@/assets/images/common/join.svg'
import landing from '@/assets/images/common/landing5-1.png'
import oneCoin from '@/assets/images/common/oneCoin.png'
import telegram from '@/assets/images/common/telegramIcon.svg'
import {adListener} from '@/utils'
export default {
  name: 'Template5',
  data () {
    return {
      join,
      landing,
      oneCoin,
      telegram,
      link: 'https://t.me/BetAjay_agent',
      link2: 'https://direct.lc.chat/12249555/14'
    }
  },
  mounted () {
    adListener('PageViewLanding')
  },
  methods: {
    joinNow () {
      localStorage.setItem('cid', this.$store.state.agentCid)
      this.$router.push('/Login?cid=' + this.$store.state.agentCid)
    },
    goto () {
      window.location.href = this.link2
    }
  }
}
</script>

<style lang="less">
.main-content {
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;

  .coin {
    //height: 25.56vw;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    //position: relative;
    //bottom: 22vw;
    //left: 3vw;
    height: 0;
    position: relative;
    top: -35vw;
    .coin_bg {
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      width: 100%;
      height: 90%;
      background-color: rgba(0, 0, 0, 0.8);

      .oneCoin {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 19.5vw;
      }

      .title {
        width: 100%;
        display: flex;
        justify-content: center;
        padding-bottom: 2.5vw;
        img {
          margin: 0 2vw;
          width: 5.72vw;
        }

        span {
          font-size: 4.3vw;
          font-weight: 700;
          line-height: 7.3vw;
          text-align: left;
          color: #F8E62E;
        }
      }

      .row {
        width: 100%;
        display: flex;
        justify-content: center;
        //font-size: 3.3vw;
        //font-weight: 700;
        //line-height: 4.9vw;
        //text-align: left;
        padding-left: 3.5vw;

        .whatsup {
          width: 85.27vw;
          height: 25.38vw;
          //border: 1px solid red;
          display: flex;
          justify-content: center;
          align-items: center;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          position: relative;
          left: 1.8vw;
          position: relative;

          span {
            position: absolute;
            left: 26vw;
            top: 3vw;
            color: #000000;
            font-size: 5.2vw;
            font-weight: 700;
          }
        }

        .w_text {
          color: #FFFFFF;
        }

        .b_text {
          margin-left: 2vw;
          color: #0495FF;
          text-decoration: underline;
        }
      }
    }
  }

  .black {
    height: 12.5vw;
  }
}

.main-content::-webkit-scrollbar {
  display: none
}

#app {
  #viewContainer {
    padding-bottom: 0px;

    .downloader {
      opacity: 0.9;
      position: fixed;
      height: 76px;
      top: 0;
      left: 0;
      width: 100vw;
      z-index: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Landing/template5.vue